
export default {
  props: {
    centered: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    leadingSubtitle: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: undefined
    }
  }
}
